import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-custom-toggle',
  templateUrl: './custom-toggle.component.html',
  styleUrls: ['./custom-toggle.component.scss'],
})
export class CustomToggleComponent {
  @Input() on: boolean = false;
  @Output() onChange: EventEmitter<boolean> = new EventEmitter();

  constructor() {}

  emitChange(): void {
    this.on = !this.on;
    this.onChange.emit(this.on);
  }

  ngOnInit(): void {}
}
